module.exports = __webpack_public_path__ + "img/badge-list-thumb-124.c4caab6f.png";